<template>
  <div
    v-if="colorDataExists && colorData.length > 1"
    class="variation-colors"
  >
    <template
      v-for="(color, index) in colorData"
    >
      <div
        v-if="index < 8"
        :key="index"
        class="variation-color"
      >
        <a
          :href="itemUrl"
        >
          <template v-if="color.description.startsWith('#')">
            <div
              class="variation-color-thumb"
              :style="'background-color:' + color.description"
              :title="color.value"
            />
          </template>
          <template v-else>
            <img
              class="variation-color-thumb"
              :src="'https://images.bundeswehr-und-mehr.de/frontend/colors/' + color.description"
              :alt="color.value"
              :title="color.value"
              loading="lazy"
            >
          </template>
        </a>
      </div>
    </template>
    <div class="more-colors-link-container">
      <a
        class="more-colors-link"
        :href="itemUrl"
      >{{ $translate("Ecomsilio::Template.moreColors", { "count": colorData.length }) }}</a>
    </div>
  </div>
</template>
<script>
export default {
    name: "VariationColors",
    props: {
        colorPropertyData: {
            type: Array
        },
        colorPropertyId: {
            type: Number,
            default: 148
        },
        itemUrl: { type: String }
    },
    computed: {
        colorDataExists ()
        {
            return this.colorPropertyData.length > 0 && this.colorPropertyData[0].properties.length > 0 && this.colorPropertyData[0].properties.find(element => element.id === this.colorPropertyId) !== undefined && this.colorPropertyData[0].properties.find(element => element.id === this.colorPropertyId) !== null
        },
        colorData ()
        {
            return this.colorPropertyData[0].properties.find(element => element.id === this.colorPropertyId).values
        }
    }
}
</script>
